import Timeout = NodeJS.Timeout;
import { Requester } from "./requester";
import { ModalBuilder } from "./modal-builder";
import { SimpleTable, SimpleTableData } from "./simple-table";
import { ButtonBuilder } from "./button-builder";
import { PanelDefinition } from "../dashboard/panels/dashboard-panel";
import { DashboardHelper } from "../dashboard/dashboard-helper";
import { ViewSettings } from "../views/view-settings";
import { Icon } from "./icon-helper";
import { Form, FormDisplayer } from "../forms/form";

export class DialogTable
{
    private readonly table = new SimpleTable();
    private readonly url: string;
    private readonly onDataChanged: () => void;
    private refreshTimeout: Timeout;
    private currentFilters: any = {};

    constructor(url: string, onDataChanged?: () => void)
    {
        this.url = url;
        this.onDataChanged = onDataChanged;
    }

    async open()
    {
        const definition: PanelDefinition = await Requester.get(this.url);
        const modal = ModalBuilder.createModal(definition.Title);
        modal.dialog.css("width", "880px");

        if (definition.SettingsUrl)
        {
            ViewSettings.addSettingsButton(modal.title, Icon.Cog, null, () =>
            {
                const form = new Form(definition.SettingsUrl);
                form.onDataChanged = () => this.reloadData(definition.DataUrl);
                FormDisplayer.openInModal(form);
            });
        }

        let filterControls: any = {};
        if (definition.Filters && definition.Filters.length > 0)
        {
            filterControls = await DashboardHelper.addFiltersRow(definition.Filters, modal.body, () =>
            {
                const newFilters: any = {};
                for (const key in filterControls)
                {
                    if (Object.prototype.hasOwnProperty.call(filterControls, key))
                    {
                        newFilters[key] = filterControls[key].getValue();
                    }
                }
                this.currentFilters = newFilters;
                this.reloadData(definition.DataUrl);
            });
        }

        this.table.appendTo(modal.body);
        await this.reloadData(definition.DataUrl);

        for (const button of DashboardHelper.getButtons(definition.Buttons, async () =>
        {
            await this.reloadData(definition.DataUrl);
            if (this.onDataChanged)
            {
                this.onDataChanged();
            }
        }))
        {
            ButtonBuilder.get({
                name: button.name,
                isSecondary: true,
                cssClass: "margin-top-5 margin-right-5",
                onClick: button.onClick
            }).appendTo(modal.body);
        }
        modal.container.modal({ show: true });
    }

    private async reloadData(dataUrl: string): Promise<void>
    {
        if (this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
        }
        const data = (<SimpleTableData> await Requester.post(dataUrl, this.currentFilters));
        this.table.setData(data, () =>
        {
            this.reloadData(dataUrl);
            if (this.onDataChanged)
            {
                this.onDataChanged();
            }
        });
        if (data.NextRefresh)
        {
            this.refreshTimeout = setTimeout(() => this.reloadData(dataUrl), data.NextRefresh * 1000);
        }
    }
}
